import {Link, useNavigate} from "react-router-dom";
import {notification} from "antd";
import {useContext} from "react";
import AuthContext from "../utilis/contexts/AuthContext";

type Props={
    name:string,
    path:string,
}
const ServiceLink = (props:Props) => {
    const authContext=useContext(AuthContext);
    const navigate=useNavigate();
  const handleNavigate=()=>{
      if(authContext.currentBranchInfo.has_debt){
          notification['error']({
              message: '',
              description: authContext.currentBranchInfo.debt_message,
              duration: 120
          });


      }else {
          navigate(`/panel/${path}`)
      }

   }
    const {path,name}=props;
    return <div onClick={handleNavigate} className="w-full block text-sm   p-3 bg-gray-100 border cursor-pointer  rounded-lg" >{name}</div>
}
export default ServiceLink;